import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const getDealDetailedViewUrl = (
  id: string | number,
  extraParams?: Record<string, string>
): string => {
  const searchParams = new URLSearchParams();

  const currentParams = new URLSearchParams(window.location.search);
  const preservedParams = ["view"];

  preservedParams.forEach((param) => {
    const value = currentParams.get(param);
    if (value) {
      searchParams.set(param, value);
    }
  });

  if (!searchParams.has("view")) {
    searchParams.set("view", "table");
  }

  if (extraParams) {
    Object.entries(extraParams).forEach(([key, value]) => {
      searchParams.set(key, value);
    });
  }

  return `/deals/${id}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
};

export const useDealsNavigation = () => {
  const navigate = useNavigate();

  const navigateToDetailedView = useCallback(
    (id: string | number, extraParams?: Record<string, string>) => {
      navigate(getDealDetailedViewUrl(id, extraParams));
    },
    [navigate]
  );

  return { navigateToDetailedView };
};
